import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';
type TPermission = {
  company_id:string;
  description:string;
  id:number;
  module_id:number;
  role_name:string;
  key:string;
  type:string;
}

type TUser = {
  name: string,
  image:string,
  id: number,
  document_number:string,
  uid: string,
  permissions:{
    views:string[],
    actions:string[]
  },
  roles:TPermission[]
}

const initialState:TUser = {
  name: "",
  image:"",
  id: 0,
  document_number:"",
  uid: "",
  permissions:{
    views:[],
    actions:[]
  },
  roles:[]
}

interface UserContextType {
  user: TUser;
  updateUser: (newConfig: Partial<TUser>) => void;
}
interface UserProviderProps {
  children: ReactNode;
}

const UserContext = createContext<UserContextType>({user:initialState,updateUser:()=>{}});

export const UserProvider:React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState(initialState);
  const updateUser = useCallback((newConfig:Partial<TUser>) => {
    setUser((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    user,
    updateUser,
  }), [user, updateUser]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};